__turbopack_context__.v({
  "activeDot": "Inw0_G_activeDot",
  "dot": "Inw0_G_dot",
  "dots": "Inw0_G_dots",
  "mobileCarousel": "Inw0_G_mobileCarousel",
  "sourceActive": "Inw0_G_sourceActive",
});
